<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="quaSearch.whCode" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId"
                                :label="item.whCode+'-'+item.whName"
                                :value="item.whCode">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="quaSearch.matCode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="quaSearch.matName" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料类型" class="EL-Form-Item">
                        <el-select v-model="quaSearch.mtType" placeholder="请选择" filterable clearable="clearable" multiple collapse-tags>
                        <el-option v-for="(item, index) in mtTypeList" :key="index" :label="item.ddCode+' - '+item.ddName" :value="item.ddCode">
                        </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--<el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="quaSearch.orderCode" placeholder="请输入"  clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>-->
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getTableData">查询</el-button>
                        <el-button class="btn-t-delete" @click="reset()">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商" class="EL-Form-Item">
                        <el-input v-model="quaSearch.svName" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="quaSearch.batchNo" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="收货人" class="EL-Form-Item">
                        <el-input v-model="quaSearch.person" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="quaSearch.boxCode" placeholder="包装箱号" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="质检结果" class="EL-Form-Item">
                        <el-select v-model="quaSearch.result" @change="getTableData()">
                            <el-option key="0" value="" label="全部"></el-option>
                            <!-- <el-option key="6" value="WAIT,PICK" label="默认（待检，挑选）"></el-option> -->
                            <el-option key="1" value="WAIT" label="待检"></el-option>
                            <el-option key="2" value="OK" label="合格"></el-option>
                            <!-- <el-option key="3" value="PICK" label="挑选"></el-option> -->
                            <el-option key="5" value="COMPLETE" label="挑选完成">挑选完成</el-option>
                            <el-option key="4" value="NOK" label="不合格"></el-option>
                            <el-option key="9" value="PASS" label="让步放行"></el-option>
                            <el-option key="10" value="RETURN" label="退货"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="quaSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date"
                            placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="quaSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date"
                            placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="检验人" class="EL-Form-Item">
                        <el-input v-model="quaSearch.checkPerson" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="检验开始" class="EL-Form-Item">
                        <el-date-picker v-model="quaSearch.qualityDate[0]" value-format="yyyy-MM-dd HH:mm" type="date"
                            placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="检验结束" class="EL-Form-Item">
                        <el-date-picker v-model="quaSearch.qualityDate[1]" value-format="yyyy-MM-dd HH:mm" type="date"
                            placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-input v-model="quaSearch.lcCode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="钢材炉号" class="EL-Form-Item">
                        <el-input v-model="quaSearch.heatNo" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="热处理批号" class="EL-Form-Item">
                        <el-input v-model="quaSearch.heatNumber" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="质检结果录入">


                <el-button v-authority="" class="btn-t-edit" @click="insertUploadFile">上传附件</el-button>
                <el-button v-authority="'BACK_MENU2_M1_B7'" class="btn-t-edit" @click="deleteQuality"
                    v-if="quaSearch.result=='WAIT'">删除质检</el-button>
                <el-button v-authority="'BACK_MENU2_M1_B5'" class="btn-t-edit"
                    @click="insertStockQualityScrap">破坏</el-button>
                <el-button v-authority="'BACK_MENU2_M1_B3'" class="btn-t-edit" @click="insertStockQualityOK"
                    v-if="quaSearch.result=='WAIT'">合格</el-button>
                <el-button v-authority="'BACK_MENU2_M1_B4'" class="btn-t-edit" @click="insertStockQualityNOK"
                    v-if="quaSearch.result=='WAIT'">不合格</el-button>
                <el-button v-authority="'BACK_MENU2_M1_B4'" class="btn-t-edit" @click="stockQualityNOKByPass"
                    v-if="quaSearch.result=='NOK'">让步放行</el-button>
                <el-button v-authority="'BACK_MENU2_M1_B4'" class="btn-t-edit" @click="stockQualityNOKByReturn"
                    v-if="quaSearch.result=='NOK'">退货</el-button>
                <el-button v-authority="'BACK_MENU2_M1_B8'" class="btn-t-edit" @click="insertStockQualityNOK"
                    v-if="quaSearch.result=='RETURN'">不合格</el-button>

                <!-- <el-button v-authority="'BACK_MENU2_M1_B5'" class="btn-t-edit" @click="saveQuality('1')">挑选</el-button> -->
                <el-button v-authority="'BACK_MENU2_M1_B6'" class="btn-t-edit" @click="saveQuality('2')"
                    v-if="quaSearch.result=='NOK'">挑选完成</el-button>
                <!-- <el-button v-authority="'menu2_2_2'" class="btn-t-edit" @click="openRemark()">添加备注</el-button> -->
                <el-button v-authority="'BACK_MENU2_M1_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary"
                    @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :summary-method="getSummaries" show-summary :headerCellStyle="quaData.headerCellStyle"
                style="flex: 1" @pageChange="getTableData" :row-class-name="tableRowClassName" :data="quaData.data"
                :ref="quaData.data" pagination :nowPage.sync="quaData.nowPage" :pageSize.sync="quaData.pageSize"
                :total.sync="quaData.total" @selectionChange="selectAll">
                <el-table-column type="selection" align="center" :selectable="checkboxSelect">
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode" width="70px;">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode" min-width="100">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName" min-width="200">
                </el-table-column>
                <el-table-column label="数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="不合格数量" align="center" prop="badNumber">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.badNumber"
                            v-if="(scope.row.sqResult == 'WAIT' && quaSearch.result == 'WAIT') || scope.row.sqResult == 'NOK'"
                            oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                        <!-- <el-input v-model="scope.row.badNumber" v-else-if="scope.row.sqResult == 'PICK'"></el-input> -->
                        <span v-else>{{scope.row.badNumber ||0}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="已破坏数量" align="center" prop="alreadyDestroyNumber">
                </el-table-column>
                <el-table-column label="破坏数量" align="center" prop="destroyNumber">
                    <template slot-scope="scope">
                        <!-- <span v-if="(quaSearch.result == 'WAIT' && scope.row.sqResult!='PICK' && scope.row.sqResult!='WAIT')|| (quaSearch.result == 'PICK' && scope.row.sqResult!='PICK' && scope.row.sqResult!='WAIT') ||(quaSearch.result == 'WAIT,PICK' && scope.row.sqResult!='PICK' && scope.row.sqResult!='WAIT')"> -->
                        <span
                            v-if="scope.row.sqResult == 'PICK' || quaSearch.result == 'WAIT' || scope.row.sqResult == 'WAIT' || scope.row.sqResult == 'NOK'">
                            <el-input v-model="scope.row.destroyNumber"
                                oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                        </span>
                        <span v-else>{{ scope.row.destroyNumber }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单编号" align="center" prop="orderCode" min-width="100">
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo" min-width="100">
                </el-table-column>
                <el-table-column label="库位" align="center" prop="laCode">
                </el-table-column>
                <el-table-column label="合格库位" align="center" prop="laGoodCode" v-if="false">
                </el-table-column>
                <!-- <el-table-column label="不合格库位" align="center" prop="laBadCode">
                    <template slot-scope="scope"> -->
                <!-- <span v-if="(scope.row.sqResult == 'NOK' && quaSearch.result == 'WAIT' ) || (scope.row.sqResult == 'COMPLETE' && quaSearch.result == 'PICK')||(quaSearch.result == 'WAIT,PICK' && scope.row.sqResult=='NOK')"> -->
                <!-- <span v-if="scope.row.sqResult == 'WAIT'">
                            <el-select v-model="scope.row.laBadCode" placeholder="请选择" clearable="clearable" filterable>
                                <el-option v-for="item in lcCodeByLcTypeList" :key="item.mdId" :label="item.laType" :value="item.laType">{{item.laType}}</el-option>
                            </el-select>
                        </span>
                        <span v-else>{{ scope.row.laBadCode }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="包装箱号" align="center" prop="boxCode" min-width="100">
                </el-table-column>
                <el-table-column label="热处理批号" align="center" prop="heatNumber">
                </el-table-column>
                <el-table-column label="钢材炉号" align="center" prop="heatNo">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs">
                </el-table-column>
                <el-table-column label="附件" align="center" prop="sqfName">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.sqfName" type="text" @click="viewFile(scope.row)">{{ scope.row.sqfName }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="质检结果" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sqResult == 'WAIT'">待检</span>
                        <span v-if="scope.row.sqResult == 'OK'">合格</span>
                        <span v-if="scope.row.sqResult == 'PICK'">挑选</span>
                        <span v-if="scope.row.sqResult == 'COMPLETE'">挑选完成</span>
                        <span v-if="scope.row.sqResult == 'NOK'">不合格</span>
                        <span v-if="scope.row.sqResult == 'CLOSE'">关闭</span>
                        <span v-if="scope.row.sqResult == 'PASS'">让步放行</span>
                        <span v-if="scope.row.sqResult == 'RETURN'">退货</span>
                    </template>
                </el-table-column>
                <el-table-column label="收货人" align="center" prop="person">
                </el-table-column>
                <el-table-column label="提交时间" align="center" prop="createTime" min-width="130">
                </el-table-column>
                <!--
                <el-table-column label="超期天数" align="center" prop="exceedLimitDate">
                </el-table-column>-->
                <el-table-column label="检验人" align="center" prop="checkPerson">
                </el-table-column>
                <el-table-column label="检验时间" align="center" prop="createTimes" min-width="130">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sqResult == 'WAIT'">

                        </span>
                        <span v-else>{{ scope.row.createTimes }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="供应商" align="center" prop="supplier">
                </el-table-column>
                <el-table-column label="材料牌号" align="center" prop="materialGrade"></el-table-column>
                <el-table-column label="批次号SBN" align="center" prop="batchSbn"></el-table-column>
                <el-table-column label="质检单号" align="center" prop="sqCode" min-width="100">
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark" width="200px;">
                    <template slot-scope="scope">
                        <!-- <span v-if="(scope.row.sqResult == 'NOK' && quaSearch.result == 'WAIT' ) || (scope.row.sqResult == 'COMPLETE' && quaSearch.result == 'PICK' && scope.row.badNumber>0) || (scope.row.sqResult == 'NOK' && quaSearch.result == 'WAIT,PICK' ) || (scope.row.sqResult == 'COMPLETE' && quaSearch.result == 'WAIT,PICK' && scope.row.badNumber>0)"> -->
                        <span v-if="scope.row.sqResult == 'PICK'">
                            <el-input v-model="scope.row.remark" />
                        </span>
                        <span v-else>
                            {{ scope.row.remark }}
                        </span>
                    </template>
                </el-table-column>

                <!-- COMPLETE -->
                <el-table-column label="操作" min-width="80" fixed="right" prop="sqResult">
                    <template slot-scope="scope">
                        <el-button
                            :disabled="scope.row.sqResult == 'COMPLETE' || scope.row.sqResult == 'WAIT' || scope.row.sqResult == 'NOK' ? false : true"
                            class="btn-t-edit" @click="detailsDialog(scope.row)" v-authority="'BACK_MENU2_M1_B2'">
                            查看
                        </el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!--查看-->
        <el-dialog title="质检详情" :visible.sync="detailsDialogShow" class="fromDialog" :style="$popups.popups(0.8,0.9)"
            :close-on-click-modal="false" :show-close="false">
            <div style="padding:10px 0 ;float:right">
                <!-- <el-button @click="qualified()" class="btn-t-edit">合格入库</el-button>
                <el-button @click="unqualified()" class="btn-t-edit">不合格入库</el-button> -->
                <el-button @click="rePrintBarcode()" class="btn-t-edit">标签打印</el-button>
            </div>

            <h-table :headerCellStyle="qualityDetailData.headerCellStyle" :style="$popups.harvestRecordStyle(0.735)"
                @pageChange="getQualityDetail" :data="qualityDetailData.data" pagination
                :nowPage.sync="qualityDetailData.pageNum" :pageSize.sync="qualityDetailData.pageSize"
                :total.sync="qualityDetailData.total" @selectionChange="selectAllPrint">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="工厂编号" align="center" prop="fcCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode" width="70px;">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="物料批次" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="检验结果" align="center" prop="sqResult">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sqResult == '10'">合格</span>
                        <span v-if="scope.row.sqResult == '20'">不合格</span>
                        <span v-if="scope.row.sqResult == '30'">破坏</span>
                        <span v-if="scope.row.sqResult == '40'">让步放行</span>
                        <span v-if="scope.row.sqResult == '50'">退货</span>
                    </template>
                </el-table-column>
                <el-table-column label="库位" align="center" prop="laCode">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs">
                </el-table-column>
                <el-table-column label="包装编号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="检验人" align="center" prop="checkPerson">
                </el-table-column>
                <el-table-column label="检验人工号" align="center" prop="checkPersonNumber">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="dialogClose" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 编辑 -->
        <el-dialog title="编辑" :visible.sync="updateShow" class="fromDialog" :style="$popups.popups(0.8,0.35)"
            :close-on-click-modal="false" :show-close="false">
            <div class="dialog-body">
                <el-form label-position="right" label-width="100px">
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="订单编号" class="EL-Form-Item">
                            <el-input v-model="updateInfo.orderCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="收货单号" class="EL-Form-Item">
                            <el-input v-model="updateInfo.odCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="质检单号" class="EL-Form-Item">
                            <el-input v-model="updateInfo.sqCode" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="物料编号" class="EL-Form-Item">
                            <el-input v-model="updateInfo.matCode"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="物料描述" class="EL-Form-Item">
                            <el-input v-model="updateInfo.matName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="物料数量" class="EL-Form-Item">
                            <el-input v-model="updateInfo.matQuan"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="6" :xl="6">
                        <el-form-item label="批次" class="EL-Form-Item">
                            <el-input v-model="updateInfo.batchNo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="updateShow = false" type="info" class="btn-t-info">取 消</el-button>
                <el-button @click="updateSure()" type="primary" class="btn-t-edit">编 辑</el-button>
            </div>
        </el-dialog>
        <el-dialog title="上传附件" :visible.sync="importInShow" class="fromDialog" :close-on-click-modal="false"
            :show-close="false" @click.stop :style="$popups.popups(0.2, 0.3)">
            <div style="margin-top: 30px;">
                <el-upload :action="action" :file-list="fileList" :limit="1" multiple :accept="accept"
                    :before-upload="handleBeforeUpload" :on-error="handleUploadError" :on-exceed="handleExceed"
                    :on-success="handleUploadSuccess" :on-change="handChange" :http-request="httpRequest"
                    :show-file-list="true" :auto-upload="false" class="upload-file-uploader" ref="upload">
                    <!-- 上传按钮 -->
                    <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px;" :disabled="fileList.length < 1" size="small" type="success"
                        @click="submitUpload">上传到服务器</el-button>
                </el-upload>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeExportModel" type="info" class="btn-t-info">取 消</el-button>
                <el-button @click="confirmUpload" type="primary" class="btn-t-edit"
          >确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style>
    .el-table .success-row {
        color: #ff0000;
    }
</style>

<script>
    import moment from "moment";
    export default {
        name: "QualityInspectionEntry",
        data() {
            return {
                quaData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //NG库位
                lcCodeByLcTypeList: [],
                num: 0,

                // 详情
                qualityDetailData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                detailsDialogShow: false,
                // 筛选条件
                quaSearch: {
                    whCode: "",
                    orderCode: "",
                    odCode: "",
                    sqCode: "",
                    boxCode: "",
                    matCode: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    result: "WAIT",
                    person: "",
                    matName: "",
                    beginTimes: "",
                    endTimes: "",
                    checkPerson:"",
                    date: [],
                    qualityDate:[],
                    lcCode:"",
                    heatNumber:"",
                    heatNo:"",
                    svName:"",
                    mtType: []
                },
                //全选
                checkList: [],
                // 编辑
                updateShow: false,
                updateInfo: {},
                warehouseList: [],
                //打印
                lazyNext: null,

                //标签打印
                selectAllPrintList: [],

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                couspdId:{},
                accept: "",
                fileList: [],
                action: "action",
                importInShow: false,
                importData: '',
                sqfName: '',
                mtTypeList: [],
            };
        },
        watch: {
            quaSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
						this.quaData.nowPage=1;
                        this.getTableData(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.quaSearch.date[0]) {
                            return time.getTime() < new Date(_this.quaSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.quaSearch.date[1]) {
                            return time.getTime() > new Date(_this.quaSearch.date[1]);
                        }
                    }
                }
            }
        },
    methods: {
        httpRequest(param) {
            console.log(param,111);
            this.sqfName = param.file.name;
            let formData = new FormData();
            formData.append("fileList", param.file);
            this.$http
                .request({
                    url: "/api/uploadFile/dosupload",
                    method: "POST",
                    headers: {
                        // "Content-Type": "multipart/form-data",
                        "X-Auth-Token": localStorage.getItem("token")
                    },
                    showLoading: true,
                    data: formData
                })
                .then(res => {
                    if (res.status === 100) {
                        this.importData = res.data || [];
                        this.$notify({
                            message: "上传成功!",
                            type: "success"
                        });
                    } else {
                        this.$notify({
                            message: res.message,
                            type: "danger"
                        });
                    }
                });
        },
        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            // 校检文件类型
            // if (this.fileType) {
            //     let fileExtension = "";
            //     if (file.name.lastIndexOf(".") > -1) {
            //         fileExtension = file.name.slice(file.name.lastIndexOf("."));
            //     }
            //     const isTypeOk =
            //         this.fileType.indexOf(fileExtension) != -1 ? true : false;

            //     if (!isTypeOk) {
            //         this.$message.error(
            //             `文件格式不正确, 请上传${this.fileType}格式文件!`
            //         );
            //         return false;
            //     }
            // }
            // 校检文件大小
            // if (this.fileSize) {
            //     const isLt = file.size / 1024 / 1024 < this.fileSize;
            //     if (!isLt) {
            //         this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
            //         return false;
            //     }
            // }
            return true;
        },
             updated() {
                this.$nextTick(() => {
                this.$refs['quaData.data'].doLayout();
                })
            },

            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value)) && (column.property == "matQuan")) {
                    sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    sums[index];
                }
                });

                return sums;
            },
            //全选
            selectAllPrint(val) {
                this.selectAllPrintList = val;
            },

          deleteQuality(){
            if (this.checkList.length == 0) {
              this.$message({
                message: "请勾选质检记录！",
                type: "warning",
              });
              return;
            }
            this.$confirm("是否确认删除?", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
                .then(() => {
                  this.$http
                      .request({
                        url: "/api/stockQuanlity/deleteQuality",
                        method: "DELETE",
                        showLoading: true,
                        data: this.checkList,
                        params: {
                          person: localStorage.getItem("user"),
                          personNumber: localStorage.getItem("empNumber")
                        }
                      })
                      .then((resp) => {
                        if (resp.status == 100) {
                          this.$message({
                            message: "确认删除成功",
                            type: "success",
                          });
                          var boxCodes ="";
                          this.checkList.forEach(ele=>{
                            boxCodes = boxCodes+ele.boxCode+",";
                          })
                          this.logRemarks = "order：质检删除成功"+boxCodes;
                        } else {
                          this.$message({
                            message: resp.message,
                            type: "error",
                          });

                          this.logRemarks = "order：质检删除失败";
                        }
                        //this.logContent = JSON.stringify(this.checkList);
                        this.systemLog();
                        this.getTableData();




                      })
                      .catch((error) => {
                        this.$message({
                          message: "操作失败:" + error.message,
                          type: "warning",
                        });
                      });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消删除",
                  });
                  this.getTableData();
                });
          },

        //   上传附件
        insertUploadFile() {
            console.log(JSON.parse(JSON.stringify(this.checkList)))
            if (this.checkList.length == 0) {
                this.$message({
                    message: "请勾选质检记录！",
                    type: "warning",
                });
                return;
            }
            this.fileList=[];
            this.importInShow = true;

        },
            // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    },
        /** 手动提交上传 */
        submitUpload() {
            if (this.fileList.length <= 0) {
                return false;
            }
            this.$refs.upload.submit();
        },
        confirmUpload() {
            this.$http
                .request({
                    url: "/api/uploadFile/insertStockQualityFile",
                    method: "POST",
                    showLoading: true,
                    data: {
                        sqfAddress: this.importData,
                        orderCode: this.checkList[0].orderCode,
                        batchNo: this.checkList[0].batchNo,
                        sqfName: this.sqfName,
                        fcCode: this.checkList[0].fcCode
                    }
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.$message({
                            message: "确认上传成功",
                            type: "success",
                        });
                        this.importInShow = false;
                        this.logRemarks = "order：质检上传成功"
                    } else {
                        this.$message({
                            message: resp.message,
                            type: "error",
                        });

                        this.logRemarks = "order：质检上传失败";
                    }
                    //this.logContent = JSON.stringify(this.checkList);
                    this.systemLog();
                    this.getTableData();

                })


        },
        viewFile(row) {
            window.open('http://192.168.150.11:9001/img/' + row.sqfAddress);
        },
    /** 文件状态改变时调用 */
    handChange(file, fileList) {
      this.fileList = fileList;
    },
    // 删除文件
    handleDelete(index) {
      this.fileList.splice(index, 1);
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`只允许上传1个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },

    // 上传成功回调

    handleUploadSuccess(res, file) {
      this.$message.success("上传成功");
      this.getTableData();
    },
    closeExportModel() {
      this.importInShow = false;
      this.getTableData();
    },

            /**
             * 合格
             */
            insertStockQualityOK() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选质检记录！",
                        type: "warning",
                    });
                    return;
                }
                var barcodeList = [];
                const res = this.checkList.every((item) => {

                    if(item.destroyNumber > 0){
                        barcodeList.push(item.boxCode);
                    }

                    if (item.matQuan < item.sampleNumber) {
                        this.$message({
                            message: "抽样数量已大于库存",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否确认合格?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockQuanlity/insertStockQualityOK",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "确认合格成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：质检结果录入合格保存成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：质检结果录入合格保存失败";
                                }
                                this.logContent = JSON.stringify(this.checkList);
                                this.systemLog();
                                this.getTableData();

                                if(barcodeList.length > 0){
                                    //this.rePrintBarcode(barcodeList);
                                }


                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消合格",
                        });
                        this.getTableData();
                    });
            },

            /**
             * 不合格
             */
            insertStockQualityNOK() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选质检记录！",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkList.every((item) => {
                    if (item.matQuan < item.sampleNumber) {
                        this.$message({
                            message: "抽样数量已大于库存",
                            type: "warning",
                        });
                        return false;
                    }else if(parseInt(item.destroyNumber) >0){
                        this.$message({
                            message: "不合格不允许输入破坏数量！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否确认不合格?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockQuanlity/insertStockQualityNOK",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "确认不合格成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：质检结果录入不合格保存成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：质检结果录入不合格保存失败";
                                }
                                this.logContent = JSON.stringify(this.checkList);
                                this.systemLog();
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消不合格",
                        });
                        this.getTableData();
                    });
            },
            /**
             * 不合格——让步放行
             */
            stockQualityNOKByPass() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选质检记录！",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkList.every((item) => {
                    if (item.sqResult!='NOK') {
                        this.$message({
                            message: "质检结果必须为不合格！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否确认将不合格品让步放行?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockQuanlity/stockQualityNOKByPass",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "不合格品让步放行成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：质检结果录入不合格品让步放行保存成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：质检结果录入不合格品让步放行保存失败";
                                }
                                this.logContent = JSON.stringify(this.checkList);
                                this.systemLog();
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消不合格品让步放行",
                        });
                        this.getTableData();
                    });
            },
            /**
             * 不合格——退货
             */
            stockQualityNOKByReturn() {

                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选质检记录！",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkList.every((item) => {
                    if (item.sqResult!='NOK') {
                        this.$message({
                            message: "质检结果必须为不合格！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否确认将不合格品退货?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockQuanlity/stockQualityNOKByReturn",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "确认不合格品退货成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：质检结果录入不合格品退货保存成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：质检结果录入不合格品退货保存失败";
                                }
                                this.logContent = JSON.stringify(this.checkList);
                                this.systemLog();
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消不合格品退货",
                        });
                        this.getTableData();
                    });
            },
            /**
             * 破坏
             */
            insertStockQualityScrap(){
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选质检记录！",
                        type: "warning",
                    });
                    return;
                }

                var barcodeList = [];

                const res = this.checkList.every(e => {

                    //判断是否填写了不合格数量
                    // if(e.destroyNumber != 0){
                    //     this.$message({
                    //         message: "请勾选质检记录！",
                    //         type: "warning",
                    //     });
                    //     return;
                    // }

                    //判断如果库存数量和破坏数量一致的话不打印标签
                    if(e.matQuan != e.destroyNumber){
                        barcodeList.push(e.boxCode);
                    }

                    if (e.sqResult != 'WAIT' && e.sqResult != 'NOK') {
                        this.$message({
                            message: "只能选择创建/不合格状态的任务！",
                            type: "warning",
                        });
                        return false;
                    }else if(e.destroyNumber == 0 || e.destroyNumber == null){
                        this.$message({
                            message: "请填写破坏数量！",
                            type: "warning",
                        });
                        return false;
                    }else if(e.matQuan - e.destroyNumber < e.alreadyDestroyNumber  ){
                        this.$message({
                            message: "破坏数量不能超过库存数量！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }

                this.$confirm("是否确认已破坏数量?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockQuanlity/insertStockQualityScrap",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "确认成功",
                                        type: "success",
                                    });

                                    //挑选完成后打印标签
                                if(barcodeList.length > 0){
                                    //this.rePrintBarcode(barcodeList);
                                }
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                        this.getTableData();
                    });
            },

            saveQuality(checkType) {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选质检记录！",
                        type: "warning",
                    });
                    return;
                }

                var barcodeList = [];

                const res = this.checkList.every((item) => {
                    if (item.sqResult == 'OK' || item.sqResult == 'COMPLETE') {
                        this.$message({
                            message: "已质检完成！！",
                            type: "warning",
                        });
                        return false;
                    }

                    //挑选完成后打印标签
                    //挑选完成只能针对 ，挑选中的进行完成
                    if(checkType == "2"){
                        barcodeList.push(item.boxCode);
                        if(item.sqResult != 'WAIT' && item.sqResult != 'NOK'){
                            this.$message({
                                message: "只能对待检/不合格的进行挑选完成",
                                type: "warning",
                            });
                            return false;
                        }
                    }

                    if(checkType == "1"){
                        if(item.sqResult != 'WAIT'){
                            this.$message({
                                message: "只能对待拣的进行挑选",
                                type: "warning",
                            });
                            return false;
                        }
                    }


                    if (item.matQuan < item.sampleNumber) {
                        this.$message({
                            message: "抽样数量已大于库存",
                            type: "warning",
                        });
                        return false;
                    } else if (item.matQuan < item.badNumber) {
                        this.$message({
                            message: "不合格数量已大于库存数量",
                            type: "warning",
                        });
                        return false;
                    } else if (item.matQuan < item.destroyNumber) {
                        this.$message({
                            message: "破坏数量已大于库存数量",
                            type: "warning",
                        });
                        return false;
                    }else if(checkType == "1" && parseInt(item.destroyNumber) >0){
                        this.$message({
                            message: "挑选不允许输入破坏数量！",
                            type: "warning",
                        });
                        return false;
                    } else if (item.remark != undefined && item.remark.length>50){
                        this.$message({
                            message: "备注不能超过50个字！",
                            type: "warning",
                        });
                        return false;
                    }else {
                        return true;
                    }



                })
                if (res == false) {
                    return false;
                }

                for(var index in this.checkList){
                    if(checkType == "1"){
                        this.checkList[index].sqResult = 'PICK' ;
                    }else if(checkType == "2"){
                        this.checkList[index].sqResult = 'COMPLETE' ;
                    }

                }
                this.$confirm("是否确认该质检结果?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockQuanlity/insertStockQuality",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "确认成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：质检结果录入保存成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：质检结果录入保存失败";
                                }
                                this.logContent = JSON.stringify(this.checkList);
                                this.systemLog();
                                this.getTableData();

                                //挑选完成后打印标签
                                if(barcodeList.length > 0){
                                    //this.rePrintBarcode(barcodeList);
                                }



                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                        this.getTableData();
                    });
            },

            //合格入库
            qualified(){
                if (this.selectAllPrintList.length == 0) {
                        this.$message({
                            message: "请勾选数据！",
                            type: "warning",
                        });
                        return;
                }
                const res = this.selectAllPrintList.every(e => {
                    if (e.sqResult != '20') {
                        this.$message({
                            message: "请选择结果为不合格的数据！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否确认入库?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/insertQualifiedWh",
                                method: "POST",
                                showLoading: true,
                                data: this.selectAllPrintList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "确认入库成功",
                                        type: "success",
                                    });
                                    this.getTableData();
                                    this.getQualityDetail(this.couspdId)
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消合格",
                        });
                    });
            },

            //不合格入库
            unqualified(){
                if (this.selectAllPrintList.length == 0) {
                        this.$message({
                            message: "请勾选数据！",
                            type: "warning",
                        });
                        return;
                }
                const res = this.selectAllPrintList.every(e => {
                    if (e.sqResult != '20') {
                        this.$message({
                            message: "请选择结果为不合格的数据！",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否确认入库?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/insertUnqualifiedWh",
                                method: "POST",
                                showLoading: true,
                                data: this.selectAllPrintList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "确认入库成功",
                                        type: "success",
                                    });
                                    this.getTableData();
                                    this.getQualityDetail(this.couspdId)
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消合格",
                        });
                    });
            },

            /**
             * 1、超过没有3天检验的则标红。
             */
            tableRowClassName({row}) {
                var dates = new Date(row.createTime);
                var end = dates.getTime(); //日期转时间戳
                var today = Date.parse(new Date()); //当前的时间戳
                var days = (end - today) / (1000 * 3600 * 24);
                if (days < -3 && row.sqResult == "WAIT") {
                    //return "success-row";
                }
            },
            /**
             * 根据工厂编号和货位类型查询货位信息
             */
            // getLcCodeByFcCodeAndType() {
            //     this.$http
            //         .request({
            //             url: "/api/location/getLaCodeAllByType",
            //             method: "GET",
            //             params: {
            //                 fcCode: localStorage.getItem("fcCode") || "",
            //                 lcType: "JY",
            //             },
            //         })
            //         .then((resp) => {
            //             if (resp.status == 100) {
            //                 this.lcCodeByLcTypeList = resp.data.list
            //             }
            //         })
            //         .catch((error) => {
            //             this.$message({
            //                 message: "操作失败",
            //                 type: "error",
            //             });
            //         });
            // },
            //获取不合格默认库位
            getLcCodeByFcCodeAndType() {
                this.$http
                    .request({
                        url: "/api/sysMaterialDeploy/getSysMaterialDeployList",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            searchType: "30",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lcCodeByLcTypeList = resp.data.list
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            },
            getTableData() {
                clearTimeout(this.isSetTimeout);
                this.$http
                    .request({
                        url: "/api/order/getStockQuality",
                        method: "GET",
                        params: {
                            whCode: this.quaSearch.whCode || null,
                            orderCode: this.quaSearch.orderCode || null,
                            odCode: this.quaSearch.odCode || null,
                            sqCode: this.quaSearch.sqCode || null,
                            matCode: this.quaSearch.matCode || null,
                            matName: this.quaSearch.matName || null,
                            batchNo: this.quaSearch.batchNo || null,
                            fcCode: this.quaSearch.fcCode || null,
                            result: this.quaSearch.result || null,
                            person: this.quaSearch.person || null,
                            boxCode: this.quaSearch.boxCode || null,
                            beginTime: this.quaSearch.date ? this.quaSearch.date[0] : null,
                            endTime: this.quaSearch.date ? this.quaSearch.date[1] : null,
                            checkPerson:this.quaSearch.checkPerson || null,
                            pageNum: this.quaData.nowPage,
                            pageSize: this.quaData.pageSize,
                            qualityBeginTime: this.quaSearch.qualityDate ? this.quaSearch.qualityDate[0] : null,
                            qualityEndTime: this.quaSearch.qualityDate ? this.quaSearch.qualityDate[1] : null,
                            lcCode:this.quaSearch.lcCode,
                            heatNumber:this.quaSearch.heatNumber,
                            heatNo:this.quaSearch.heatNo,
                            svName:this.quaSearch.svName,
                            mtType: this.quaSearch.mtType.join(",") || null
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            if (res.data.total > 0) {
                                res.data.list.forEach(ele=>{
                                    var create = new Date(ele.createTime).getTime();
                                    var present = new Date().getTime();
                                    if (Math.floor((present - create) / (24 * 60 * 60 * 1000)) - 4 > 0) {
                                        ele.exceedLimitDate = Math.floor((present - create) / (24 * 60 * 60 * 1000)) - 3;
                                    }else{
                                        ele.exceedLimitDate = "";
                                    }
                                    // if(this.lcCodeByLcTypeList.length != 0){
                                        // ele.laBadCode = this.lcCodeByLcTypeList[0].laType;
                                    // }
                                })
                            }
                            this.quaData.data = res.data.list;
                            this.quaData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            heatNumberClick(row) {
                this.$set(row, "clicktext", true);
            },

            //详情
            getQualityDetail(row) {
                this.couspdId = row ;
                this.$http
                    .request({
                        url: "/api/order/getQualityDetail",
                        method: "GET",
                        params: {
                            sqId: row.sqId || null,
                            pageNum: this.qualityDetailData.nowPage,
                            pageSize: this.qualityDetailData.pageSize,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.qualityDetailData.data = res.data.list;
                            this.qualityDetailData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //禁选
            checkboxSelect(row, rowIndex) {
                if (row.sqResult == "CLOSE") {
                    return false; // 禁用
                } else {
                    return true; // 不禁用
                }
                return true;
            },
            //全选
            selectAll(val) {
                this.checkList = val;
            },

            /**
             * 详情
             */
            detailsDialog(row) {
                if(row.sqId  == undefined || row.sqId  == 0){
                    this.$message({
                        message: "当前记录没有详情",
                        type: "warning",
                    });
                    return;
                }

                this.detailsDialogShow = true;
                this.getQualityDetail(row);
            },

            dialogClose() {
                this.detailsDialogShow = false;
            },
            /**
             * 编辑
             */
            updateDialog() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选质检记录！",
                        type: "warning",
                    });
                    return;
                }

                if (this.checkList.length > 1) {
                    this.$message({
                        message: "只能选择一条质检记录！",
                        type: "warning",
                    });
                    return;
                }
                this.updateShow = true;
                this.updateInfo = this.checkList[0];
            },

            updateSure() {
                this.$confirm("是否确认编辑?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/order/updateStockQuality",
                                method: "PUT",
                                showLoading: true,
                                data: this.updateInfo,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "编辑成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：质检结果录入编辑成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：质检结果录入编辑失败";
                                }
                                this.logContent = JSON.stringify(this.updateInfo);
                                this.systemLog();
                                this.updateShow = false;
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消收货",
                        });
                    });
            },

            /**
             * 删除
             */
            deleteSure() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选质检记录！",
                        type: "warning",
                    });
                    return;
                }
                this.$confirm("是否删除该质检记录?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let suIds = "";
                        this.checkList.forEach((comp) => {
                            suIds = suIds + comp.sqId + ",";
                        });

                        this.$http
                            .request({
                                url: "/api/order/deleteStockQuality",
                                method: "DELETE",
                                params: {
                                    sqIds: suIds,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "删除成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "order：质检结果录入删除成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "order：质检结果录入删除失败";
                                }
                                this.logContent = "suIds：" + suIds;
                                this.systemLog();
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },
            /**
             * 重置
             */
            reset() {
                this.quaSearch = {
                    whCode: "",
                    orderCode: "",
                    odCode: "",
                    sqCode: "",
                    boxCode: "",
                    matCode: "",
                    batchNo: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    result: "WAIT",
                    person: "",
                    matName: "",
                    beginTimes: "",
                    endTimes: "",
                    checkPerson:"",
                    date: [],
                    qualityDate: [],
                    mtType: []
                };
            },
            /**
             * 获取通道数据
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //标签打印
            rePrintBarcode(barcodeList) {
                var boxBarcodeList = [];
                let boxBarcode = "";
                if(barcodeList != undefined && barcodeList.length > 0){
                    boxBarcode = barcodeList.join(',')
                }else{
                    if (this.selectAllPrintList.length == 0) {
                        this.$message({
                            message: "请勾选打印单！",
                            type: "warning",
                        });
                        return;
                    }

                    for (let i in this.selectAllPrintList) {
                        boxBarcodeList.push(this.selectAllPrintList[i].boxBarcode);
                    }
                    boxBarcode = boxBarcodeList.join(',')
                }

                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.$http
                        .request({
                            url: "/api/order/QualityInventory",
                            method: "GET",
                            showLoading: true,
                            params: {
                                boxBarcodeList: boxBarcode
                            },
                        })
                        .then((res) => {
                            if (res.status == 100) {
                                this.printList = res.data.list;
                                //打印
                                this.printList.forEach((item) => {
                                    var produceTime = moment(item.matCreateTime).format("YYYYMMDD");

                                    //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                                    // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                                    //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                                    //     "/" + produceTime + "/" + item.boxHeight + "/";

                                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                    var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                        item.matCode + "," + item.matQuan + "," + item.matSpecs +
                                        "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                                    if (item.matSpecs == undefined) {
                                        item.matSpecs = "";
                                    }

                                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                    var barcodeData = {
                                        boxBarcode: item.boxBarcode,
                                        prodCode: item.matCode,
                                        prodName: item.matName,
                                        batchNo: item.batchNo,
                                        count: item.matQuan,
                                        checkPerson: localStorage.getItem("empNumber"),
                                        date: produceTime,
                                        poCode: item.orderCode,
                                        matSpecs: item.matSpecs,
                                        whCode: item.whCode,
                                        qrCode: qrCode,
                                        supply: "",
                                        printTime: printTime,
                                        location: item.lcCode,
                                        isSta: true
                                    }

                                    this.$printer.printWMSBarcode(barcodeData);
                                })

                            } else {
                                this.$message({
                                    message: res.message,
                                    type: "warning",
                                });
                            }
                        });

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },


            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    whCode: this.quaSearch.whCode || null,
                    orderCode: this.quaSearch.orderCode || null,
                    odCode: this.quaSearch.odCode || null,
                    sqCode: this.quaSearch.sqCode || null,
                    matCode: this.quaSearch.matCode || null,
                    matName: this.quaSearch.matName || null,
                    batchNo: this.quaSearch.batchNo || null,
                    fcCode: this.quaSearch.fcCode || null,
                    result: this.quaSearch.result || null,
                    person: this.quaSearch.person || null,
                    boxCode: this.quaSearch.boxCode || null,
                    beginTime: this.quaSearch.date ? this.quaSearch.date[0] : null,
                    endTime: this.quaSearch.date ? this.quaSearch.date[1] : null,
                    checkPerson:this.quaSearch.checkPerson || null,
                    qualityBeginTime: this.quaSearch.qualityDate ? this.quaSearch.qualityDate[0] : null,
                    qualityEndTime: this.quaSearch.qualityDate ? this.quaSearch.qualityDate[1] : null,
                    lcCode:this.quaSearch.lcCode,
                    heatNumber:this.quaSearch.heatNumber || null,
                    heatNo:this.quaSearch.heatNo || null,
                    svName:this.quaSearch.svName,
                    pageNum: 1,
                    pageSize: 999999,
                    mtType: this.quaSearch.mtType.join(",") || null
                }
                this.$http.request({
                    url: '/api/order/getStockQuality',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.sqType == '10') {
                            c['sqType'] = '全检'
                        } else if (c.sqType == '20') {
                            c['sqType'] = '免检'
                        } else if (c.sqType == '30') {
                            c['sqType'] = '抽检'
                        }

                        if (c.sqResult == 'WAIT') {
                            c['sqResult'] = '待检'
							c['createTimes'] = ''
                        } else if (c.sqResult == 'OK') {
                            c['sqResult'] = '合格'
                        } else if (c.sqResult == 'PICK') {
                            c['sqResult'] = '挑选'
                        } else if (c.sqResult == 'NOK') {
                            c['sqResult'] = '不合格'
                        } else if (c.sqResult == 'COMPLETE') {
                            c['sqResult'] = '挑选完成'
                        } else if (c.sqResult == 'CLOSE') {
							c['sqResult'] = '关闭'
						} else if (c.sqResult == 'PASS') {
                            c['sqResult'] = '让步放行'
                        } else if (c.sqResult == 'RETURN') {
							c['sqResult'] = '退货'
						}

                        var create = new Date(c.createTime).getTime();
                        var present = new Date().getTime();
                        if (Math.floor((present - create) / (24 * 60 * 60 * 1000)) - 4 > 0) {
                            c.exceedLimitDate = Math.floor((present - create) / (24 * 60 * 60 * 1000)) - 3;
                        }else{
                            c.exceedLimitDate = "";
                        }
                    })
                    const tHeader = ['通道编号', '物料编号', '物料描述', '数量', '不合格数量', '破坏数量', '订单编号', '批次号', '库位', '不合格库位', '包装箱号','热处理批号','钢材炉号', '钢号', '规值', '质检结果', '收货人', '提交时间','超期天数', '检验人', '检验时间','供应商','材料牌号','批次号SBN','质检单号','备注']
                    const filterVal = ['whCode', 'matCode', 'matName', 'matQuan', 'badNumber', 'destroyNumber', 'orderCode',  'batchNo', 'laCode', 'laBadCode', 'boxCode', 'heatNumber','heatNo', 'steelGrade', 'matSpecs', 'sqResult','person', 'createTime','exceedLimitDate', 'checkPerson', 'createTimes','supplier','materialGrade','batchSbn','sqCode',  'remark'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '质检结果录入'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_quality：导出质检结果录入记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "质检录入",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
            //获取类型
            getmtTypeList() {
                this.$http.request({
                    url: "/api/dictData/getDictData",
                    method: "GET",
                    showLoading: true,
                    params: {
                        ddCode: "MDTYPE",
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.mtTypeList = resp.data.list || [];
                    }
                }).catch((error) => { });
            },
        },
        activated(){
            // 从页面跳转传值
            let orderCode = this.$route.query.orderCode
            let boxCode = this.$route.query.boxCode
            let sqCode = this.$route.query.sqCode
            if (orderCode) {
                this.quaSearch.orderCode = orderCode
                this.quaSearch.boxCode = boxCode
                this.quaSearch.sqCode = sqCode
            }
            this.getWarehouse();
            this.getLcCodeByFcCodeAndType();

			/* 获取首页的数据 */
			 this.getTableData();

             this.getmtTypeList();
        },
    };
</script>

<style scoped>
</style>
